module.exports = __webpack_public_path__ + "img/gfxb20220915.64e3f21f.jpg";